export default __webpack_public_path__ + "static/media/BizHub-BAM-logo.79e4ba8b.png";